<template>
  <div class="d-flex justify-space-between my-5">
    <div class="w-25 pr-5">
      <v-text-field
        label="Order Number"
        v-model="number"
        @change="$emit('update:number', $event)"
        dense
        solo
        append-icon="shopping_basket"
        hide-details
      >
      </v-text-field>
    </div>
    <div class="w-25 pr-5">
      <v-autocomplete
        :items="surgeries"
        label="Surgery"
        v-model="surgeryId"
        @change="$emit('update:surgeryId', $event)"
        dense
        solo
        append-icon="apartment"
        item-text="name"
        item-value="id"
        hide-details
      ></v-autocomplete>
    </div>
    <div class="w-25 pr-5">
      <v-autocomplete
        :items="orderStatuses"
        v-model="orderStatusId"
        @change="$emit('update:orderStatusId', $event)"
        item-text="name"
        item-value="id"
        label="Order Status"
        dense
        append-icon="tab"
        solo
        hide-details
      ></v-autocomplete>
    </div>
    <div class="w-25 text-right">
      <v-btn class="px-2 w-100" color="primary" @click="$emit('apply')"
        >Apply filters</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    number: {
      type: String,
      default: null
    },
    surgeryId: {
      type: String,
      default: null
    },
    orderStatusId: {
      type: String,
      default: null
    }
  },
  computed: {
    surgeries() {
      let surgeries = this.$store.state.surgeries.surgeries;
      surgeries.unshift({
        name: "All",
        id: null
      });
      return surgeries;
    },
    orderStatuses() {
      let orderStatuses = this.$store.state.orders.orderStatuses;
      orderStatuses.unshift({
        name: "All",
        id: null
      })
      return orderStatuses;
    }
  },
  async mounted() {
    await this.$store.dispatch("surgeries/LOAD_SURGERIES", {
      from: 0,
      to: 0
    });
    await this.$store.dispatch("orders/LOAD_ORDER_STATUSES", {
      from: 0,
      to: 0
    }) 
  }
};
</script>
